import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	header: {
		display: "flex",
		alignItems: "center",
		fontWeight: theme.typography.fontWeightBold,
		fontSize: "1em",
		marginBottom: theme.spacing(0.5),
	},
	icon: {
		fontSize: "1.1em",
		marginRight: theme.spacing(0.5),
	},
	meta: {
		opacity: 0.9,
		fontSize: "0.85em",
		marginBottom: theme.spacing(0.75),
	},
	body: {
		wordBreak: "break-word",
		fontSize: "0.95em",
		lineHeight: 1.5,
	},
	cta: {
		marginTop: theme.spacing(1),
		fontSize: "0.85em",
		opacity: 0.85,
		fontStyle: "italic",
	},
}));

export const ChatToast = ({ message }) => {
	const classes = useStyles();
	const translate = useTranslate();
	const { header, meta, body } = message;
	return (
		<div>
			<div className={classes.header}>
				<ChatBubbleOutlineIcon className={classes.icon} />
				{header}
			</div>
			{meta && <div className={classes.meta}>{meta}</div>}
			{body && <div className={classes.body}>{body}</div>}
			<div className={classes.cta}>
				{translate("toast.view_conversation")}
			</div>
		</div>
	);
};
